export const MillisecondConvesion = {
  MINUTE_IN_MS: 60000,
  HOUR_IN_MS: 3600000,
  DAY_IN_MS: 86400000,
  WEEK_IN_MS: 604800016.56,
  MONTH_IN_MS: 2629800000,
  YEAR_IN_MS: 31557600000,
};
